import styled from 'styled-components';
export const ModalWrapper = styled.div `
  background-color: #00000055;
  border: 0;
  display: flex;
  height: 100%;
  justify-content: center;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: var(--z-index-900-modal, 900);
  transition: opacity var(--transition-timing-ease) var(--transition-duration-3);
  opacity: 0;
  visibility: hidden;
  will-change: transform;
  pointer-events: none;
  align-items: flex-end;

  &[aria-hidden='false'] {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }

  @media (min-width: 480px) {
    align-items: center;
  }

  ${({ variant }) => variant === 'filter' &&
    `
      align-items: flex-end;
      transition: opacity ease 300ms;

      &[aria-hidden='false'] {
        align-items: center;
      }

      &.show {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
      }

      @media (max-width: 481px) {
        align-items: flex-end;
      }
  `}
`;
export const DefaultModal = styled.div `
  background-color: var(--modal-background-color);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  max-height: var(--modal-max-height);
  min-height: 200px;
  padding: var(--spacing-3) var(--spacing-4);
  position: relative;
  opacity: 0;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  transform: translateY(100%) scale(0.9);
  transition: all var(--transition-timing-ease) var(--transition-duration-3);

  &[data-show='true'] {
    opacity: 1;
    transform: translateY(0);
  }

  &[data-size='small'] {
    width: 400px;
  }

  &[data-size='medium'] {
    width: 600px;
  }

  &[data-size='large'] {
    width: 800px;
  }

  @media (min-width: 480px) {
    border-radius: var(--border-radius-md);
    transform: translateY(10%) scale(0.9);

    &[data-show='true'] {
      opacity: 1;
      transform: scale(1);
    }
  }
`;
export const FilterModal = styled.div `
  background-color: white;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  transition: opacity ease 300ms;
  opacity: 0;
  transition: all ease 0.3s;
  transform: translateY(10%) scale(0.9);

  &.show {
    opacity: 1;
    transform: scale(1);
  }

  @media (max-width: 481px) {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    transform: translateY(100%) scale(0.9);

    &.show {
      transform: translateY(0);
    }
  }
`;
export const DefaultContent = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: var(--color-neutral-80);
    border-radius: var(--border-radius-md);
  }

  ::-webkit-scrollbar-thumb {
    background: var(--color-neutral-110);
    border-radius: var(--border-radius-md);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--color-neutral-110);
  }
`;
export const FilterContent = styled.div `
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;
  padding: 0 0 20px 0;
  overflow-y: auto;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 15px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #aaa;
    border-radius: 15px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #888;
  }
`;
